import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useAllocModel } from "../allocModel";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAllocModel();
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品编号",
            fieldName: "materialCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品名称",
            fieldName: "materialName"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "调拨单号",
            fieldName: "code"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "调出站点",
            fieldName: "outShopId",
            options: allShopDs,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "出库状态",
            fieldName: "stockOutStatus",
            options: []
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "调入站点",
            fieldName: "shopId",
            options: allShopDs,
        },
    ]
    const searchMoreFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "入库状态",
            fieldName: "stockInStatus",
            options: []
        },
    ]
    return (
        <YhPageHeader
            title="调拨统计"
            size="small"

            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}